import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import useBoundStore from "store";

export function useAnalytics() {
    const user = useBoundStore((s) => s.user);

    useEffect(() => {
        if (user) {
            Sentry.setUser({
                username: `${user.firstName ?? ''} ${user.lastName ?? ''}`,
                fullName: `${user.firstName ?? ''} ${user.lastName ?? ''}`,
                email: user.email,
                id: user.id
            });
        }
    }, [user])
}